import React, {useState} from "react";
import CompanyProfileCardsList from "../Company/CompanyProfileCardsList";
import {ZapleczeHeader} from "../ZapleczeHeader";
import {Box} from "@mui/material";
import {CompanyMenu} from "../Company/CompanyMenu";
import {CompanyHorizontalMenuPanel} from "../Company/CompanyHorizontalMenuPanel";


export const CompanyProfileCardsPanel = (
    {
        profile,
        token,
        pageTitle,
        contextList,
        setSelectedContext,
        selectedContext,
        setOpenInProgress,
        isAdmin
    }
) => {
    const [menuIx,      setMenuIx]      = useState(CompanyMenu.RANGE_AREA);
    const [profilerefs, setProfileRefs] = useState([]);

    return (
        <>
            <ZapleczeHeader pageTitle={pageTitle}
                            contextList={contextList}
                            setSelectedContext={setSelectedContext}
                            selectedContext={selectedContext}
                            isAdmin={isAdmin}
            >
                <CompanyHorizontalMenuPanel setMenuIx={setMenuIx} menuIx={menuIx} isAdmin={isAdmin} />
            </ZapleczeHeader>

            <Box className='main-panel'>
                <CompanyProfileCardsList profile={profile}
                                         token={token}
                                         setopenInProgress={setOpenInProgress}
                                         menuIx={menuIx}
                                         profilerefs={profilerefs}
                                         setProfileRefs={setProfileRefs}
                />

            </Box>
        </>
    )
}
